export default {
  menuItemAddCompany: {
    notes: 'Menuitem label for creating a new company',
    message: 'Create new',
  },
  menuItemImportFromMdg: {
    notes: 'Menuitem label for importing a new company from MDG',
    message: 'Import from MDG',
  },
  addCompanyDialogTitle: {
    notes: 'Title of add company dialog',
    message: 'Add company',
  },
  addCompanyStepOne: {
    notes: 'Title of first step in stepped dialog for add company',
    message: 'Company details',
  },
  addCompanyStepTwo: {
    notes: 'Title of second step in stepped dialog for add company',
    message: 'User details',
  },
  departmentOf: {
    notes:
      'Label for checkbox isDepartment, when creating a company/department',
    message: '{{companyName}} is a department of {{parentCompanyName}}',
  },
};
